import React from 'react';
import { usePackages } from '../../../contexts/PackagesContext';
import { Checkbox } from '../../../components/ui/Input';

// ── Non-gated capability flags ────────────────────────────────────────────
// These are plain capability toggles NOT enforced by the check.feature
// middleware. They stay hardcoded here exactly as before.
const CAPABILITY_FEATURES = [
  'full_player_offline', 'advance_content_schedule', 'published_as_grouping',
  'content_preview', 'music_list_access', 'ai_access',
  'interactive_action', 'add_users', '3d', 'device_preview', 'voice_call',
  // NOTE: prayer_app, live_meeting_access, rss_feed, layouts, weather, clock,
  // animated_layouts, remote_control moved to the GATED list (config/features.php)
  // — they now render via the fetched /admin/features section, not here.
];

// Display labels for capability keys that don't render nicely from
// key.replace(/_/g, ' ').
const CAPABILITY_LABEL_OVERRIDES = {};

// NOTE: the gated-flag list (and its offline fallback) moved to
// PackagesContext so this component and the wizard's submit payload read the
// SAME array. See the comment there.

export default function Step2({ errors, clearErrors, setError }) {
  // gatedFeatures is fetched once in PackagesContext and shared with the
  // wizard's submit payload, so what is rendered here is by construction what
  // gets saved. Do not re-fetch it locally — that split is what silently
  // dropped qr_loyalty on every package save.
  const { selectedFeature, setSelectedFeature, gatedFeatures } = usePackages();

  const toggle = (feature, checked) => {
    const next = checked
      ? [...selectedFeature, feature]
      : selectedFeature.filter(f => f !== feature);
    setSelectedFeature(next);
    if (next.length > 0) clearErrors('features');
    else setError('features', { message: 'Select at least one feature.' });
  };

  return (
    <div>
      <p className="text-text-muted text-sm mb-4">Select the features included in this plan.</p>
      <div className="grid grid-cols-2 gap-3">
        {CAPABILITY_FEATURES.map(f => (
          <Checkbox
            key={f}
            id={`feature-${f}`}
            label={CAPABILITY_LABEL_OVERRIDES[f] ?? f.replace(/_/g, ' ')}
            checked={selectedFeature.includes(f)}
            onChange={e => toggle(f, e.target.checked)}
          />
        ))}
      </div>

      <p className="text-text-muted text-sm mt-6 mb-4">Premium / gated features.</p>
      <div className="grid grid-cols-2 gap-3">
        {gatedFeatures.map(f => (
          <Checkbox
            key={f.key}
            id={`feature-${f.key}`}
            label={f.label ?? f.key.replace(/_/g, ' ')}
            checked={selectedFeature.includes(f.key)}
            onChange={e => toggle(f.key, e.target.checked)}
          />
        ))}
      </div>

      {errors.features && <p className="mt-3 text-xs text-danger">{errors.features.message}</p>}
    </div>
  );
}
